import React from 'react';
import { useOffer } from '../contexts/OfferContext';
import { valueMathConfig } from '../data/siteConfig';
import { formatARS } from '../utils/currency';
export const ValueMathSection = () => {
  const {
    price,
    priceLabel
  } = useOffer();
  const {
    sesionDomicilio,
    libroActividades
  } = valueMathConfig;
  const total = sesionDomicilio + libroActividades;
  const savings = total - price;
  const perDay = Math.round(price / 365);
  const rows = [<>
      Una sesión particular de kinesiología a domicilio puede rondar los{' '}
      <span className="font-bold text-familia-ink" data-id="element-291" data-mp="3vzujhxuah7kl">
        {formatARS(sesionDomicilio)}
      </span>
      . Es una sola sesión;{' '}
      <span className="font-bold text-familia-ink" data-id="element-292" data-mp="dqlevpmeygkc">
        Vitalidad 360 te acompaña durante todo el año.
      </span>
    </>, <>
      Un libro individual de actividades de estimulación para adultos mayores
      puede costar alrededor de{' '}
      <span className="font-bold text-familia-ink" data-id="element-293" data-mp="1l5gf3qxyo6tu">
        {formatARS(libroActividades)}
      </span>{' '}
      y suele incluir una cantidad limitada de propuestas.
    </>, <>
      Buscar, elegir y adaptar más de 150 actividades para distintos niveles
      puede llevar horas{' '}
      <span className="font-bold text-familia-ink" data-id="element-294" data-mp="1s94f9h6xxdx0">
        —y muchas veces semanas—
      </span>{' '}
      de prueba.
    </>];
  return <section className="bg-familia-light border-t border-familia-lightBorder py-12 md:py-16 px-4 md:px-6" data-id="element-295" data-mp="1x6cyll3trnzu">
      <div className="max-w-3xl mx-auto w-full" data-id="element-296" data-mp="10gdf4vm4z52h">
        <h2 className="text-[26px] sm:text-3xl md:text-4xl font-display font-bold text-familia-ink text-center mb-8 md:mb-10 leading-tight" data-id="element-297" data-mp="14ktjutk0k6g4">
          ¿Por qué {priceLabel} es una inversión accesible?{' '}
          <span className="text-familia-accent" data-id="element-298" data-mp="1eamrxkky63fm">Hagamos la cuenta.</span>
        </h2>
        <div className="bg-familia-lightCard border border-familia-lightBorder rounded-2xl overflow-hidden" data-id="element-299" data-mp="guz6mavs8fvc">
          <ul className="divide-y divide-familia-lightBorder" data-id="element-300" data-mp="ls8wfrn32tjp">
            {rows.map((row, i) => <li key={i} className="text-body text-familia-inkMuted px-6 md:px-8 py-5" data-id="element-301" data-mp="1p3699v8jp3hk" data-mpi={i}>
                {row}
              </li>)}
          </ul>
          <div className="bg-familia-dark text-white px-6 md:px-8 py-6 md:py-7 text-center" data-id="element-302" data-mp="1xv867jjeo1n3">
            <p className="text-[15px] md:text-[16px] font-bold uppercase tracking-wider text-familia-onDarkMuted" data-id="element-303" data-mp="1tw7oy5gkt727">
              Una sesión + un libro:{' '}
              <span className="text-white" data-id="element-304" data-mp="1168yc5mqh1vf">{formatARS(total)}</span>
            </p>
            <p className="mt-3 text-[20px] md:text-2xl font-display font-bold leading-snug" data-id="element-305" data-mp="118llcx7cm2fc">
              Con Vitalidad 360 hoy invertís{' '}
              <span className="text-familia-accent" data-id="element-306" data-mp="1a6nrfr5xvl9h">{priceLabel}</span> y
              ahorrás{' '}
              <span className="text-familia-gold" data-id="element-307" data-mp="2qkdxh3gmcjlr">{formatARS(savings)}</span>.
            </p>
            <p className="mt-4 pt-4 border-t border-familia-darkBorder text-body text-familia-onDarkMuted" data-id="element-308" data-mp="2lmvoxe6ik6ea">
              Si lo usás durante un año, te cuesta aproximadamente{' '}
              <span className="font-bold text-white" data-id="element-309" data-mp="2y4ga3novkpo7">${perDay} por día</span>.
            </p>
          </div>
        </div>
        <p className="text-body font-semibold text-familia-ink text-center mt-6 md:mt-8" data-id="element-310" data-mp="2k5qd08222pzu">
          Y lo imprimís las veces que quieras: para tu mamá, para la tía y para
          el cuidador.
        </p>
        <p className="text-[13px] text-familia-inkMuted text-center mt-4 max-w-2xl mx-auto leading-relaxed" data-id="element-311" data-mp="3cungh51lyi8j">
          Valores de referencia de mercado en Argentina. Pueden variar según
          zona y proveedor. Vitalidad 360 no reemplaza la evaluación ni el
          tratamiento indicado por profesionales de la salud.
        </p>
      </div>
    </section>;
};